import { AccountSettingsViewProps } from "@/common/contracts/account.contracts";
import { PaymentSettingsPage } from "@/components/Account/payment/PaymentSettingsPage";

/**
 * The Payment settings view of Accountinstellingen. The page itself lives
 * in `payment/`; this module keeps the name the settings routing and the
 * dashboard import.
 */
export { StripeAccountButton } from "@/components/Account/payment/StripeAccountButton";

export const AccountSettingsPaymentInformation = ({
  title,
}: AccountSettingsViewProps) => <PaymentSettingsPage title={title} />;
